import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=68d54447&scoped=true&"
import script from "./AlertSuccess.vue?vue&type=script&lang=ts&"
export * from "./AlertSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSuccess.vue?vue&type=style&index=0&id=68d54447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d54447",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
